import { EditHeader } from 'components/Card'
import { useFormContext } from 'react-hook-form'
import { formatAddress } from 'utils/address'
import { Cell, CellValue, Row, RowLabel, TextAutocomplete, PV1Card } from '../../Card/PV1Card'
import type { PV1PrescriberEditFormSchemaType } from './PV1PrescriberEditForm.validator'

export const PV1PrescriberEditForm = ({
  rxPrescriberData,
  pv1PrescriberCardData,
  editHeaderActions,
  onSubmit,
}: {
  rxPrescriberData: any
  pv1PrescriberCardData: any
  editHeaderActions: any
  onSubmit: (data: any) => void
}) => {
  const {
    getValues,
    setValue,
    formState: { errors },
  } = useFormContext<PV1PrescriberEditFormSchemaType>()

  return (
    <form onSubmit={onSubmit} data-testid="pv1-prescriber-edit-form">
      <PV1Card data-testid="PV1PrescriberCard" title={<EditHeader {...editHeaderActions} />}>
        <Row rowSpan={2} data-testid="prescriber">
          <Cell $borderBottom>
            <RowLabel bold>Prescriber</RowLabel>
          </Cell>
          <Cell $paddingLeft $borderBottom $borderRight>
            <CellValue>{rxPrescriberData.prescriber?.value}</CellValue>
          </Cell>
          <Cell $paddingLeft $borderBottom>
            <TextAutocomplete
              value={getValues().prescriber || ''}
              options={['Smith Jane DR', 'Doe Jhon DR']}
              variant="small"
              state={errors.prescriber ? 'error' : 'default'}
              helperText={errors?.prescriber?.message || ''}
              onChange={value => {
                if (value === getValues().prescriber) return

                if (!value) {
                  setValue('prescriber', '', { shouldValidate: true })
                } else {
                  setValue('prescriber', value, { shouldValidate: true })
                }
              }}
            />
          </Cell>
        </Row>
        <Row rowSpan={2} data-testid="credential">
          <Cell $borderBottom>
            <RowLabel bold>Credential</RowLabel>
          </Cell>
          <Cell $paddingLeft $borderBottom $borderRight>
            <CellValue>{rxPrescriberData.credential?.value}</CellValue>
          </Cell>
          <Cell $paddingLeft $borderBottom>
            <CellValue>{pv1PrescriberCardData.credential?.value}</CellValue>
          </Cell>
        </Row>
        <Row rowSpan={2} data-testid="address">
          <Cell $borderBottom>
            <RowLabel bold>Address</RowLabel>
          </Cell>
          <Cell $paddingLeft $borderBottom $borderRight>
            <CellValue>{formatAddress(rxPrescriberData.address?.value)}</CellValue>
          </Cell>
          <Cell $paddingLeft $borderBottom>
            <TextAutocomplete
              value={getValues().address || ''}
              options={['456 Clinic Rd, Healthtown, CA 67890', '73069 Kris Knoll Port Maxime, AL 61961']}
              variant="small"
              state={errors.address ? 'error' : 'default'}
              helperText={errors?.address?.message || ''}
              onChange={value => {
                if (value === getValues().address) return

                if (!value) {
                  setValue('address', '', { shouldValidate: true })
                } else {
                  setValue('address', value, { shouldValidate: true })
                }
              }}
            />
          </Cell>
        </Row>
        <Row rowSpan={2} data-testid="phone">
          <Cell $borderBottom>
            <RowLabel bold>Phone</RowLabel>
          </Cell>
          <Cell $paddingLeft $borderBottom $borderRight>
            <CellValue>{rxPrescriberData.phone.value}</CellValue>
          </Cell>
          <Cell $paddingLeft $borderBottom>
            <CellValue>{pv1PrescriberCardData.phone.value}</CellValue>
          </Cell>
        </Row>
        <Row rowSpan={2} data-testid="npi">
          <Cell $borderBottom>
            <RowLabel bold>NPI</RowLabel>
          </Cell>
          <Cell $paddingLeft $borderBottom $borderRight>
            <CellValue>{rxPrescriberData.npi.value}</CellValue>
          </Cell>
          <Cell $paddingLeft $borderBottom>
            <CellValue>{pv1PrescriberCardData.npi.value}</CellValue>
          </Cell>
        </Row>
        <Row rowSpan={2} data-testid="dea">
          <Cell>
            <RowLabel bold>DEA</RowLabel>
          </Cell>
          <Cell $paddingLeft $borderRight>
            <CellValue>{rxPrescriberData.dea.value}</CellValue>
          </Cell>
          <Cell $paddingLeft>
            <CellValue>{pv1PrescriberCardData.dea.value}</CellValue>
          </Cell>
        </Row>
      </PV1Card>
    </form>
  )
}
